import React from "react";

import CurrentCoverageCard from "./CurrentCoverageCard";

export default function CurrentCoveragesPanel({
  coverages = [],
  settings,
}) {
  if (!Array.isArray(coverages) || coverages.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-4">
        <h3 className="text-base font-semibold text-slate-900">
          Current Coverages
        </h3>

        <p className="text-sm text-slate-500 mt-1">
          No active coverage is currently linked to this scenario.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4 mt-4">
      <div>
        <h3 className="text-base font-semibold text-slate-900">
          Current Coverages
        </h3>

        <p className="text-sm text-slate-500 mt-1">
          Active financing arrangements linked to this scenario.
        </p>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        {coverages.map((coverage) => (
          <CurrentCoverageCard
            key={
              coverage.scenario_coverage_id ??
              coverage.id
            }
            coverage={coverage}
            settings={settings}
          />
        ))}
      </div>
    </div>
  );
}